import React, { useEffect } from "react";
import { DateRange } from "react-date-range";
import { useRangoFechas } from "./../../../../Shared/Hooks/Custom.hooks";
import "./FiltroFechas.component.scss";

const FiltroFechasComponent = ({ filtroFechas = () => {} }) => {
  const [fechas, setFechas] = useRangoFechas();

  const handleChangeFechas = (fechas) => {
    setFechas(fechas);
  };

  useEffect(() => {
    const { endDate, startDate } = fechas[0];

    filtroFechas(startDate, endDate);
  }, [fechas]);

  return (
    <DateRange
      editableDateInputs={true}
      onChange={(item) => handleChangeFechas([item.selection])}
      moveRangeOnFirstSelection={false}
      ranges={fechas}
    />
  );
};

export default FiltroFechasComponent;
